import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat-footer"
}
const _hoisted_2 = { class: "actions-container" }
const _hoisted_3 = { class: "summary-actions" }
const _hoisted_4 = { class: "thumbs-wrapper" }
const _hoisted_5 = { class: "thumb-btn-wrapper" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "thumb-btn-wrapper" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "summary-actions" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "thumbs-down-popover" }
const _hoisted_13 = { class: "thumbs-down-footer" }
const _hoisted_14 = { style: {"padding":"var(--w-space-sm)"} }
const _hoisted_15 = { style: {"display":"flex","gap":"var(--w-space-s)","justify-content":"flex-end","padding":"var(--w-space-sm)"} }
const _hoisted_16 = { style: {"padding":"var(--w-space-sm)"} }
const _hoisted_17 = { style: {"display":"flex","gap":"var(--w-space-s)","justify-content":"flex-end","padding":"var(--w-space-sm)"} }

import { ref, inject, computed, watch } from "vue";
import { UserTracking } from "@/utils/UserTracking";
import { trackNoaRumAction, NOA_RUM_EVENT } from "@/utils/noaObservability";
import { useStateMachine } from "@/composables/useStateMachine";
import { useSessionStore } from "@/composables/useSessionStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryFooter',
  props: {
  summaryStatus: {
    type: String,
    required: true,
  },
  reviewStatus: {
    type: String,
    required: true,
  },
  actionState: {
    type: String,
    required: true,
  },
  initialContext: {
    type: Object,
    required: true,
  },
  customForms: {
    type: Array,
    required: true,
  },
  preemiumConfig: {
    type: Object,
    required: true,
  },
  summaryText: {
    type: String,
    required: true,
  },
},
  emits: ["summarySaved", "summaryDenied", "close"],
  setup(__props, { emit: __emit }) {

const machine = useStateMachine();
const sessionStore = useSessionStore();

const props = __props;

const emit = __emit;

const apiClient = inject<{
  post: (url: string, data: any) => Promise<any>;
  put: (url: string, data: any) => Promise<any>;
}>("apiClient");
const ratting = ref(null);
const showThumbsDownModal = ref(false);
const thumbsDownComment = ref("");

const handleThumbsUpClick = () => {
  ratting.value = true;
  sendRattingToBackend();
};

const handleThumbsDownClick = () => {
  showThumbsDownModal.value = true;
  ratting.value = false;
};

const submitThumbsDown = () => {
  sendRattingToBackend();
  showThumbsDownModal.value = false;
  thumbsDownComment.value = "";
};

const cancelThumbsDown = () => {
  showThumbsDownModal.value = false;
  thumbsDownComment.value = "";
  ratting.value = null;
};

const sendRattingToBackend = async () => {
  try {
    await apiClient.post(`/session/${props.initialContext.recorderSessionId}/summary/rating`, {
      rating: ratting.value ? "Like" : "Dislike",
      comment: thumbsDownComment.value,
    });
    toastsData.value = [
      {
        content: "Feedback enviado com sucesso!",
        variant: "default",
        timeOut: 3000,
      },
    ];
  } catch (error) {
    console.error("Failed to send ratting to backend:", error);
    toastsData.value = [
      {
        content: "Erro ao enviar feedback.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    ratting.value = null;
  }
};

const loadingFormGenerate = ref(false);
const stateSavingSummary = ref(false);
const disableButtonGenerateDocument = ref(props.reviewStatus === "pending" ? true : false);
const toastsData = ref([]);
const originalText = ref("");
const hasChanges = ref(false);
const showCloseConfirmationModal = ref(false);
const showSaveConfirmationModal = ref(false);

const isAlfa = computed(() => props.initialContext.licenseId === 17973 || props.initialContext.licenseId === 9326);
const isPreemium = computed(() => props.initialContext.isPreemium);

// Initialize state based on review status only (not text changes)
watch(
  () => props.reviewStatus,
  (newStatus) => {
    if (newStatus === "pending") {
      disableButtonGenerateDocument.value = true;
      originalText.value = ""; // For pending reviews, no original text yet
      hasChanges.value = true; // Allow saving without edits for new reviews
    } else if (newStatus === "reviewed") {
      disableButtonGenerateDocument.value = false;
      originalText.value = props.summaryText || ""; // Set current text as original for reviewed
      hasChanges.value = false; // No changes initially for reviewed summaries
    }
  },
  { immediate: true },
);

const freemiumRemainingDays = computed(() =>
  Math.ceil((new Date().getTime() - new Date(props.preemiumConfig.releaseDate).getTime()) / (1000 * 60 * 60 * 24)),
);
const freemiumLimitExceeded = computed(() =>
  props.preemiumConfig.active && props.preemiumConfig.mode === "time"
    ? freemiumRemainingDays.value >= props.preemiumConfig.limit
    : !isPreemium.value && props.initialContext.transcriptionsThisMonth >= props.preemiumConfig.credits,
);

const freemiumExceededMessage = computed(() => {
  if (props.preemiumConfig.active && props.preemiumConfig.mode === "time") {
    if (freemiumLimitExceeded.value) {
      return "Seu período de teste acabou!";
    }
    return `${props.preemiumConfig.limit - freemiumRemainingDays.value} dias do Pro restantes`;
  }
  return `${props.initialContext.transcriptionsThisMonth}/${props.preemiumConfig.credits} resumos grátis este mês`;
});

// Helper function to normalize text for comparison (handle HTML differences)
const normalizeText = (text) => {
  if (!text) return "";
  return text
    .replace(/\s+/g, " ") // Normalize whitespace
    .replace(/<p><\/p>/g, "") // Remove empty paragraphs
    .replace(/<p><br><\/p>/g, "") // Remove empty paragraphs with line breaks
    .trim();
};

// Watch for text changes after initialization
watch(
  () => props.summaryText,
  (newText, oldText) => {
    const normalizedNew = normalizeText(newText);
    const normalizedOriginal = normalizeText(originalText.value);

    // For pending reviews, always allow save (first save)
    if (props.reviewStatus === "pending") {
      hasChanges.value = true;
    } else if (props.reviewStatus === "reviewed") {
      // For reviewed summaries, check if text actually changed from the saved version
      const textChanged = normalizedNew !== normalizedOriginal;
      hasChanges.value = textChanged;
    }
  },
);

// Update original text when review status changes to reviewed
watch(
  () => props.reviewStatus,
  (newStatus, oldStatus) => {
    if (newStatus === "reviewed" && oldStatus === "pending") {
      originalText.value = props.summaryText;
      hasChanges.value = false;
      disableButtonGenerateDocument.value = false;
    }
  },
);

const onClickSaveSummary = () => {
  if (!hasChanges.value) {
    return;
  }
  // Show save confirmation modal
  showSaveConfirmationModal.value = true;
};

const confirmSaveSummary = async () => {
  showSaveConfirmationModal.value = false;
  stateSavingSummary.value = true;
  machine.setSummarySaving(true);
  try {
    const response = await apiClient.put(`/session/${props.initialContext.recorderSessionId}`, {
      summary: props.summaryText,
      status: "Verified",
    });

    // Track BEFORE eval(jsCommand) — `reloadTimeline()` can destroy the Vue
    // iframe before async-tracking calls flush. See docs/ehr/known-issues.md
    // item #10 ("reviewed without noa_notes_added in Amplitude").
    UserTracking.trackEvent("noa_notes_added", {
      page_category: "noa notes",
      page_section: "",
    });
    trackNoaRumAction(NOA_RUM_EVENT.SUMMARY_ACCEPTED, {
      session_id: props.initialContext.recorderSessionId ?? "unknown",
      save_path: "summary_footer",
    });

    if (response.jsCommand) {
      sessionStore.setReloadTimeline(response.jsCommand);
      eval(response.jsCommand);
    }

    stateSavingSummary.value = false;
    disableButtonGenerateDocument.value = false;
    originalText.value = props.summaryText;
    hasChanges.value = false;

    machine.send({ type: "WS_VERIFIED" });
    machine.setSummarySaving(false);
    emit("summarySaved");
  } catch (error) {
    toastsData.value = [
      {
        content: "Erro ao salvar resumo.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    machine.setSummarySaving(false);
    stateSavingSummary.value = false;
  }
};

const onClickClose = () => {
  // If there are unsaved changes, show confirmation modal
  if (hasChanges.value) {
    showCloseConfirmationModal.value = true;
  } else {
    // No changes, just close
    emit("close");
  }
};

const confirmClose = async () => {
  // Close modal first
  showCloseConfirmationModal.value = false;

  try {
    await apiClient.put(`/session/${props.initialContext.recorderSessionId}`, {
      summary: props.summaryText,
      status: "Discarded",
    });
    trackNoaRumAction(NOA_RUM_EVENT.SUMMARY_DISCARDED, {
      session_id: props.initialContext.recorderSessionId ?? "unknown",
      had_changes: hasChanges.value,
    });
  } catch (error) {
    console.error("[SummaryFooter] Error discarding session:", error);
    toastsData.value = [
      {
        content: "Erro ao descartar resumo.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    return;
  }

  // Emit close/discard after API call
  emit("summaryDenied");
};

return (_ctx: any,_cache: any) => {
  const _component_w_button = _resolveComponent("w-button")!
  const _component_w_badge = _resolveComponent("w-badge")!
  const _component_w_toast = _resolveComponent("w-toast")!
  const _component_w_text = _resolveComponent("w-text")!
  const _component_w_modal = _resolveComponent("w-modal")!

  return (__props.summaryStatus === 'ready' && __props.actionState === 'summary')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["thumb-btn thumb-down", { active: ratting.value === false }]),
                  disabled: ratting.value === false,
                  "data-dd-action-name": "noa_summary_thumbs_down",
                  onClick: handleThumbsDownClick
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" }),
                    _createElementVNode("path", { d: "M17 14V2" })
                  ], -1)
                ]))], 10, _hoisted_6),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "thumb-tooltip" }, "Thumbs down", -1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["thumb-btn thumb-up", { active: ratting.value === true }]),
                  disabled: ratting.value === true,
                  "data-dd-action-name": "noa_summary_thumbs_up",
                  onClick: handleThumbsUpClick
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" }),
                    _createElementVNode("path", { d: "M7 10v12" })
                  ], -1)
                ]))], 10, _hoisted_8),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "thumb-tooltip" }, "Thumbs up", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_w_button, {
              loading: stateSavingSummary.value,
              label: "Fechar",
              variant: "neutral",
              onClick: onClickClose,
              class: "close-button",
              "data-dd-action-name": "noa_summary_close"
            }, null, 8, ["loading"]),
            _createVNode(_component_w_button, {
              loading: stateSavingSummary.value,
              disabled: !hasChanges.value,
              "leading-icon": "check",
              label: "Aceitar e salvar resumo",
              variant: !hasChanges.value ? 'neutral' : 'primary',
              style: _normalizeStyle(!hasChanges.value ? 'cursor: not-allowed;' : ''),
              onClick: onClickSaveSummary,
              class: "save-button",
              "data-dd-action-name": "noa_summary_save"
            }, null, 8, ["loading", "disabled", "variant", "style"])
          ])
        ]),
        (isAlfa.value && !isPreemium.value && __props.preemiumConfig.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_w_badge, {
                type: freemiumLimitExceeded.value ? 'danger' : 'neutral',
                class: "freemium-badge"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(freemiumExceededMessage.value)
                  }, null, 8, _hoisted_11)
                ]),
                _: 1
              }, 8, ["type"]),
              (freemiumLimitExceeded.value)
                ? (_openBlock(), _createBlock(_component_w_button, {
                    key: 0,
                    class: "pro-button",
                    label: "Desbloquear Plano Pro",
                    loading: stateSavingSummary.value,
                    href: "https://feegowclinic.com.br/software-para-dentistas-0?hs_preview=YHApGUcG-183768869505",
                    target: "_blank",
                    variant: "plain",
                    "leading-icon": "star"
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (showThumbsDownModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "thumbs-down-overlay",
              onClick: _withModifiers(cancelThumbsDown, ["self"])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", { class: "thumbs-down-header" }, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "thumbs-down-title" }, "O que podemos melhorar?", -1)),
                  _createElementVNode("button", {
                    class: "thumbs-down-close",
                    onClick: cancelThumbsDown
                  }, "×")
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "thumbs-down-description" }, "Conte-nos o que não ficou bom no resumo.", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thumbsDownComment).value = $event)),
                  rows: "3",
                  placeholder: "Escreva seu comentário aqui...",
                  class: "thumbs-down-textarea"
                }, null, 512), [
                  [_vModelText, thumbsDownComment.value]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_w_button, {
                    variant: "outlined",
                    label: "Cancelar",
                    onClick: cancelThumbsDown
                  }),
                  _createVNode(_component_w_button, {
                    variant: "filled",
                    label: "Enviar",
                    onClick: submitThumbsDown
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_w_toast, { toasts: toastsData.value }, null, 8, ["toasts"]),
        _createVNode(_component_w_modal, {
          modelValue: showCloseConfirmationModal.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showCloseConfirmationModal).value = $event)),
          size: "medium",
          title: "Sair sem salvar?",
          "close-on-click-outside": false,
          style: {"z-index":"99999999999"},
          class: "close-confirmation-modal"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_w_text, {
                type: "body",
                "tag-type": "p"
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Você não salvou este resumo. Se sair agora, este resumo será descartado. ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_w_button, {
                label: "Cancelar",
                variant: "neutral",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showCloseConfirmationModal.value = false)),
                "data-dd-action-name": "noa_summary_close_cancel"
              }),
              _createVNode(_component_w_button, {
                label: "Descartar",
                variant: "danger",
                onClick: confirmClose,
                "data-dd-action-name": "noa_summary_discard_confirm"
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_w_modal, {
          modelValue: showSaveConfirmationModal.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showSaveConfirmationModal).value = $event)),
          size: "medium",
          title: "Salvar resumo?",
          "close-on-click-outside": false,
          style: {"z-index":"99999999999"},
          class: "save-confirmation-modal"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_w_text, {
                type: "body",
                "tag-type": "p"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Ao salvar, o resumo será enviado para o prontuário do paciente e ", -1),
                  _createElementVNode("b", null, "um formulário será gerado.", -1),
                  _createTextVNode(" Esta ação não pode ser desfeita. ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_w_text, {
                type: "body",
                "tag-type": "p",
                style: {"margin-top":"var(--w-space-s)"}
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" Deseja continuar? ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_w_button, {
                label: "Cancelar",
                variant: "neutral",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showSaveConfirmationModal.value = false))
              }),
              _createVNode(_component_w_button, {
                label: "Salvar resumo",
                variant: "primary",
                onClick: confirmSaveSummary
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})